import { useLocation, Navigate } from 'react-router-dom';

/**
 * TrailingSlashEnforcer
 * 
 * Redirects any URL without trailing slash to its trailing-slash version.
 * This eliminates duplicate pages (e.g., /contact vs /contact/) for SEO.
 * 
 * Excluded paths:
 * - Root "/" (already canonical)
 * - Paths with file extensions (e.g., /sitemap.xml)
 * - Paths with dynamic tokens (/manage/:token, /feedback/:token)
 */
const TrailingSlashEnforcer = () => {
  const location = useLocation();
  const { pathname, search, hash } = location;

  // Skip: root, already has trailing slash, file extensions, dynamic token paths
  if (
    pathname === '/' ||
    pathname.endsWith('/') ||
    pathname.includes('.') ||
    pathname.startsWith('/manage/') ||
    pathname.startsWith('/feedback/') ||
    pathname.startsWith('/admin/')
  ) {
    return null;
  }

  // Redirect to trailing-slash version (replace = no back-button loop)
  return <Navigate to={`${pathname}/${search}${hash}`} replace />;
};

export default TrailingSlashEnforcer;
